<template>
  <div id="app" v-cloak>
    <router-view  v-if="isShow"/>
  </div>
</template>

<script>

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isShow: true
    };
  },
  mounted() {
  },
  methods: {
    reload() {
      this.isShow = false;
      this.$nextTick(() => {
        this.isShow = true;
      });
    }
  }
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
[v-cloak] {
  display: none;
}
</style>